<template>
  <div id="personalevaluation">
    <div class="personalaccount_content">
      <div class="personalaccount_content_left">
        <div class="personalaccount_content_left_item">
          <div class="personalaccount_content_left_item_head">基础功能</div>
          <div class="personalaccount_content_left_item_content">
            <div class="personalaccount_content_left_item_content_box">
              <router-link to="/shopcarIndex">我的购物车</router-link>
            </div>
            <div class="personalaccount_content_left_item_content_box">
              <router-link to="/personalOrder" class>订单管理</router-link>
            </div>
            <div class="personalaccount_content_left_item_content_box select_box">
              <router-link to="/personalservice" class="select_box">售后申请</router-link>
            </div>
            <div class="personalaccount_content_left_item_content_box">
              <router-link to="/personaCollection" class>我的收藏</router-link>
            </div>
            <div class="personalaccount_content_left_item_content_box">
              <router-link to="/personalHistory" class>浏览历史</router-link>
            </div>
          </div>
        </div>
        <div class="personalaccount_content_left_item">
          <div class="personalaccount_content_left_item_head">我的优惠信息</div>
          <div class="personalaccount_content_left_item_content">
            <div class="personalaccount_content_left_item_content_box">
              <router-link to="/personalPackage" class>我的红包</router-link>
            </div>
            <div class="personalaccount_content_left_item_content_box">
              <router-link to="/personalIntegral" class>我的积分</router-link>
            </div>
          </div>
        </div>
        <div class="personalaccount_content_left_item">
          <div class="personalaccount_content_left_item_head">发票管理</div>
          <div class="personalaccount_content_left_item_content">
            <div class="personalaccount_content_left_item_content_box">
              <router-link to="/personalTicket">申请开票</router-link>
            </div>
          </div>
        </div>
      </div>
      <div class="personalaccount_content_right">
        <div class="personalaccount_content_right_head1">
          <div class="personalaccount_content_right_head_left">订单号：{{shoptxt.trade_no}}</div>
          <div class>
            <span style="display: inline-block;margin-right: 20px;" @click="deleteOrder">删除订单</span>
            <span @click="$router.back(-1)">返回</span>
          </div>
        </div>
        <div class="personalaccount_content_right_box">
          <div class="personalaccount_content_right_head">
            <div class="personalaccount_content_right_head_left">商品列表</div>
          </div>

          <div class="personalaccount_content_right_content">
            <el-table
              :data="shopdata"
              border
              style="width: 100%"
              :header-cell-style="getRowClass"
              :cell-style="cellStyle"
            >
              <el-table-column label="商品信息" width="420">
                <template slot-scope="scope">
                  <div class="tabshopimgbox flex">
                    <img :src="http + scope.row.goods_image" alt class="tabshopimg" />
                    <div class="tabshoptxt txtnowarp2">{{scope.row.goods_name}}</div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="goods_spec_value" label="属性"></el-table-column>
              <el-table-column label="本店价">
                <template slot-scope="scope">
                  <div class="tabshopimgbox flex">{{scope.row.price*1 | filterA}}</div>
                </template>
              </el-table-column>
              <el-table-column prop="number" label="购买数量"></el-table-column>
              <el-table-column label="小计">
                <template slot-scope="scope">
                  <div
                    class="tabshopimgbox flex c_red"
                  >{{scope.row.price*scope.row.number*scope.row.package | filterA}}</div>
                </template>
              </el-table-column>
              <el-table-column fixed="right" label="操作">
                <template slot-scope="scope">
                  <el-button
                    v-if="scope.row.status=='1'"
                    type="text"
                    @click="jumpSq(scope.$index, scope.row)"
                    style="color: #ffffff;font-size: 16px;backgroundColor:#408cff;padding:15px;"
                  >申请售后</el-button>
                  <el-button
                    v-else
                    style="padding:15px;"
                    @click="jumplook(scope.$index, scope.row,oderid)"
                  >查看进度</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
         <div class="personalaccount_content_right_footer">
            <div class="personalaccount_content_right_footer_left">费用总计</div>
            <div class="personalaccount_content_right_footer_center">已选{{shoptxt.number}}件商品 <br/>
              订单完成您获得{{jifen}}积分。</div>
            <div class="personalaccount_content_right_footer_right">
              <div class="personalaccount_content_right_footer_right_con">
                <span class="personalaccount_content_right_footer_right_con5">商品总额：</span>
                <span class="personalaccount_content_right_footer_right_con2">{{parseFloat(shoptxt.payment)|filterB}}</span>
              </div>
              <div class="personalaccount_content_right_footer_right_con">
                <span class="personalaccount_content_right_footer_right_con1">物流费用：</span>
                <span class="personalaccount_content_right_footer_right_con2">+{{parseFloat(shoptxt.postage)  | filterB }}</span>
              </div>
              <div class="personalaccount_content_right_footer_right_con">
                <span class="personalaccount_content_right_footer_right_con1">积分抵扣：</span>
                <span class="personalaccount_content_right_footer_right_con4">- {{parseFloat(shoptxt.discount) | filterB }}</span>
              </div>

              <div class="personalaccount_content_right_footer_right_con">
                <span class="personalaccount_content_right_footer_right_con5">订单总金额：</span>
                <span class="personalaccount_content_right_footer_right_con3"><em>￥</em> {{(parseFloat(shoptxt.payment)+parseFloat(shoptxt.postage)) | filterB}}</span>
              </div>
            </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import qs from "qs";

import DateSelect from "@/components/DateSelect";
export default {
  name: "personalevaluation",

  components: {
    DateSelect
  },
  filters: {
    //过滤器一：（使用时没有参数，即{{msg|filterA}}）
    filterA(value) {
      return "￥" + parseFloat(value.toFixed(2));
    },
     filterB(value) {
      return  parseFloat(value.toFixed(2));
    }
  },
  data() {
    return {
      fixedkey: false,
      tableData: [
        {
          name: "UB6090S123朝阳U品60*90CM双面耐擦白板(白+绿)",
          num: "(白+绿)",
          dyprice: 2
        },
        {
          name: "UB6090S123朝阳U品60*90CM双面耐擦白板(白+绿)",
          num: "(白+绿)",
          dyprice: 2
        }
      ],
      dingdanData: [],
      shopdata: [],
      http: "",
      shoptxt: "",
      userid: "",
      oderid: "", //订单id
      oderinner:'',
      odernumval:"",
      jifen:0
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  created() {
    let that = this;
    // console.log("用户信息");

    // console.log(that.$storage.get("user_data"));
    if (that.$storage.get("user_data") != null) {
      that.dingdanData["user_id"] = that.$storage.get("user_data").user_id;
      that.userid = that.$storage.get("user_data").user_id;
      that.dingdanData["id"] = that.$route.query.id;
      that.odernumval=that.$route.query.odernum;
      that.oderid = that.$route.query.id;
      that.getDingdan();
    }
    that.http = that.$publicUrl.http1;
  },
  methods: {
    handleScroll() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (scrollTop >= 300) {
        this.fixedkey = true;
      } else {
        this.fixedkey = false;
      }
    },
    dateChange(obj) {
      console.log(obj.year + "-" + obj.month + "-" + obj.day);
    },
    getRowClass({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background: #eeeeee;font-size:18px;color:#333333;text-align:center;border-right:1px solid #eeeeee;font-weight:500";
      } else {
        return "";
      }
    },
    cellStyle({ row, column, rowIndex, columnIndex }) {
      if (columnIndex == 5) {
        return "text-align:center;font-size:16px;color:#333333;";
      } else {
        return "text-align:center;font-size:16px;color:#333333;";
      }
    },
    handleEdit(index, row) {
      let that = this;
      that.$router.push({ path: "/personalTicketYz", query: { id: "1" } });
    },
    jumpSq(index, row) {
      let that = this;
      console.log(row)
      that.$router.push({
        path: "/personalservicecreate",
        query: {
          shopid: row.id,
          odernunmber: that.shoptxt.trade_no
        }
      });
    },
    jumplook(index, row) {
      let that = this;
      that.$router.push({
        path: "/personalevaluationslook",
        query: {
          shopid: row.id,
          oderid: that.oderid,
          odernunmber: that.shoptxt.trade_no,
          shopskuid: row.sku_id
        }
      });
    },
    getDingdan() {
      let that = this;
      axios({
        method: "post",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
        },
        url: that.$publicUrl.http1 + that.$publicUrl.ordergetOrder,
        data: qs.stringify(that.dingdanData)
      })
        .then(function(response) {
          let data = response.data;

          if (data.stateCode == 10000) {
            that.shoptxt = data.data;
            that.shopdata = data.data.order_skus;
            that.getintegral()
          } else {
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    getintegral(){
      let that = this;
      axios({
            method: "post",
            headers: {
              "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
            },
            url: that.$publicUrl.http1 + that.$publicUrl.getintegral,
            data: qs.stringify({
              user_id: that.$storage.get("user_data").user_id,
              money:(parseFloat(that.shoptxt.payment)+parseFloat(that.shoptxt.postage)),
              rank:that.$storage.get("user_data").rank_id
            })
          })
            .then(function(response) {
              //						console.log(response);
              let data = response.data;
               that.jifen=data.data.get                        
              if (data.stateCode == 10000) {
              } else {
              }
            })
            .catch(function(error) {
              console.log(error);
            });
    },
    deleteOrder() {
      let that = this;
      that
        .$confirm("您将删除该条订单吗?", "系统提示", {
          confirmButtonText: "确定删除",
          cancelButtonText: "我再想想",
          center: true,
          customClass: "alertboxq",
          confirmButtonClass: "alertboxqbtn1"
        })
        .then(() => {
          axios({
            method: "post",
            headers: {
              "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
            },
            url: that.$publicUrl.http1 + that.$publicUrl.orderstate,
            data: qs.stringify({
              user_id: that.$storage.get("user_data").user_id,
              order_id: that.oderid
            })
          })
            .then(function(response) {
              //						console.log(response);
              let data = response.data;
              if (data.stateCode == 10000) {
                this.$confirm("订单删除成功返回上一步", "提示", {
                  confirmButtonText: "确定",
                  cancelButtonText: "取消",
                  type: "warning"
                })
                  .then(() => {
                    that.$router.back(-1);
                  })
                  .catch(() => {
                    that.$router.back(-1);
                  });
              } else {
              }
            })
            .catch(function(error) {
              console.log(error);
            });
        })
        .catch(() => {});
    }
  }
};
</script>

<style scoped="scoped">
#personalevaluation {
  width: 100%;
  background-color: #f6f6f6;
  padding-top: 20px;
  padding-bottom: 20px;
}

.personalaccount_content {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-wrap: nowrap;
 align-items: self-start;
}

.personalaccount_content_left {
  width: 170px;
  text-align: center;
  background: #ffffff;
}

.personalaccount_content_left_item_head {
  width: 100%;
  height: 50px;
  line-height: 50px;
  background: #dddddd;
  color: #333333;
  font-size: 18px;
  font-weight: 550;
}

.personalaccount_content_left_item_content {
  width: 100%;
}

.personalaccount_content_left_item_content_box {
  font-size: 16px;
  color: #333333;
  width: 100%;
  height: 40px;
  margin-top: 10px;
  line-height: 40px;
}

.select_box {
  background: #dc1e33;
  color: #ffffff;
}

.personalaccount_content_left_item_content_box span {
  color: #dc1e33;
}

.personalaccount_content_right {
  width: 1010px;
  margin-left: 20px;
  cursor: pointer;
  /*background: #ffffff;*/
}

.personalaccount_content_right_content {
  width: calc(100%);
  box-sizing: border-box;
  padding: 20px 0;
  /*justify-content: space-between;*/
}

.personalaccount_content_right_head {
  height: 50px;
  line-height: 50px;
  box-sizing: border-box;
  padding-left: 20px;
  padding-right: 20px;
  width: 100%;
  background: #fe818d;
  color: #ffffff;
  font-size: 18px;
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
}

.personalaccount_content_right_content_item {
  width: 182px;
  background: #ffffff;
  margin-top: 20px;
  margin-right: calc((100% - 182px * 5) / 10);
  margin-left: calc((100% - 182px * 5) / 10);
}

.personalaccount_content_right_content_item_head {
  width: 100%;
}

.personalaccount_content_right_content_item_head img {
  width: 100%;
  display: inline-block;
}

.personalaccount_content_right_content_item_center {
  font-size: 14px;
  color: #333333;
  margin: 0 auto;
  margin-top: 10px;
  width: 100%;
  box-sizing: border-box;
  padding-left: 10px;
  padding-right: 10px;
}

.personalaccount_content_right_content_item_footer {
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  box-sizing: border-box;
  width: 100%;
  padding: 10px;
}

.personalaccount_content_right_content_item_footer img {
  display: inline-block;
  width: 16px;
  height: 20px;
  margin-top: 3px;
}

.personalaccount_content_right_content_item_footer_txt {
  color: #dc1e33;
  font-size: 18px;
}

.personalaccount_content_right_footer_txt1 {
  color: #333333;
}
.personalaccount_content_right_footer_txt2 {
  color: #dc1e33;
}
.personalaccount_content_right_footer_btn {
  display: inline-block;
  width: 160px;
  height: 50px;
  line-height: 50px;
  text-align: center;
  color: #ffffff;
  margin-left: 30px;
  background: #dc1e33;
  border-radius: 5px;
}
.personalaccount_content_right_footer {
  display: flex;
  flex-wrap: nowrap;
  width: 100%;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 10px;
  background: #ffffff;
  margin: 40px auto;
 align-items: center;
}
.personalaccount_content_right_footer_left {
  height: calc(100% - 20px);
  line-height: 140px;
  color: #333333;
  font-size: 24px;
  margin-left: 10px;
}
.personalaccount_content_right_footer_center {
  width: 410px;
  font-size: 16px;
  color: #333333;
  line-height: 30px;
  box-sizing: border-box;
}
.personalaccount_content_right_footer_right_con {
  font-size: 16px;
  color: #333333;
  height: 35px;
  line-height: 35px;
  /*text-align: right;*/
}
.personalaccount_content_right_footer_right_con span {
  display: inline-block;
  margin-left: 5px;
}
.personalaccount_content_right_footer_right_con1 {
  display: inline-block;
  width: 100px;
  text-align: right;
}
.personalaccount_content_right_footer_right_con5 {
  display: inline-block;
  width: 100px;
  text-align: right;
}
.personalaccount_content_right_footer_right_con2 {
  color: #dc1e33;
}
.personalaccount_content_right_footer_right_con3 {
  font-size: 20px;
  color: #dc1e33;
}

.personalaccount_content_right_head1 {
  height: 50px;
  line-height: 50px;
  box-sizing: border-box;
  padding-left: 20px;
  padding-right: 20px;
  width: 100%;
  background: #eeeeee;
  color: #333333;
  font-size: 18px;
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  margin-bottom: 20px;
}
.personalaccount_content_right_head {
  height: 50px;
  line-height: 50px;
  box-sizing: border-box;
  padding-left: 20px;
  padding-right: 20px;
  width: 100%;
  color: #000000;
  background: #ffffff;
  font-size: 18px;
  border-bottom: 1px solid #dc1e33;
  margin-top: 20px;
}
.personalaccount_content_right_box {
  width: 100%;
  background-color: #ffffff;
  box-sizing: border-box;
  padding: 0 22px;
  overflow: hidden;
}
.tabshopimgbox {
  width: 100%;
  box-sizing: border-box;
  padding: 20px;
}
.tabshopimg {
  width: 60px;
  height: 60px;
  display: block;
  border: 1px solid #dddddd;
  margin-right: 20px;
}
.tabshoptxt {
  width: cala(100% - 80px);
  height: 60px;
  line-height: 30px;
  font-size: 16px;
  text-align: left;
}
.c_red {
  color: #dc1e33;
}
em{
  font-style:normal;
  color: #dc1e33;
font-size: 14px;
}
</style>